import api from './api'

interface ResumeUploadResponse {
  message: string
  profile: {
    username: string
    full_name: string
  }
}

export const resumeService = {
  async uploadResume(
    file: File,
    onProgress?: (progress: number) => void
  ): Promise<ResumeUploadResponse> {
    const formData = new FormData()
    formData.append('resume', file)

    const response = await api.post('/resumes', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          onProgress(percentCompleted)
        }
      },
    })

    return response.data
  },
}
